import React from "react";
import { Container } from "./styled";
const NotFoundPage = () => {
    return (
        <Container>
           <div><h3>404 Not found Page</h3> </div>
        </Container>
    )
}

export default NotFoundPage;